import { render, staticRenderFns } from "./reply.vue?vue&type=template&id=2ef2ce81&scoped=true"
import script from "./reply.vue?vue&type=script&lang=js"
export * from "./reply.vue?vue&type=script&lang=js"
import style0 from "./reply.vue?vue&type=style&index=0&id=2ef2ce81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2ce81",
  null
  
)

export default component.exports